import { useContext } from "react";
import { AuthContext } from "../contexts/contextExporter";

export function useAuth() {
  return useContext(AuthContext);
}
